import { render, staticRenderFns } from "./OrderDetailsSummary.vue?vue&type=template&id=f43ee5fc&scoped=true&"
import script from "./OrderDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsSummary.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=f43ee5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43ee5fc",
  null
  
)

export default component.exports